import * as _ from 'lodash';
import { fromJS } from 'immutable';

import { fetchingState } from '@constants';
import * as actions from '../actions/event';

const initialStats = {
  event: { data: {}, state: null },
  tags: { data: [], state: null },
  objects: { data: [], state: null },
  persists: {
    eventData: {},
  },
  documentList: { data: [], state: null },
  lastPosition: 0,
  lastTopPosition: 0,
  uploadedImages: { data: [], state: null },
  linkedImages: { data: [], state: null },
  linkedImage: { data: {}, state: null },
  linkedEvents: { data: [], state: null },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case actions.EVENT_CREATE_START: {
      return state.setIn(['event', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_CREATE_SUCCESS: {
      return state
        .setIn(['event', 'state'], fetchingState.LOADED)
        .setIn(
          ['event', 'data'],
          fromJS(_.get(action, 'data.results.event[0]', {})),
        )
        .setIn(['tags', 'data'], fromJS(_.get(action, 'data.results.tags', [])))
        .setIn(
          ['objects', 'data'],
          fromJS(_.get(action, 'data.results.eventObjects', [])),
        );
    }
    case actions.EVENT_CREATE_ERROR: {
      return state.setIn(['event', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_FETCH_START: {
      return state
        .setIn(['event', 'data'], fromJS({}))
        .setIn(['event', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_FETCH_SUCCESS: {
      return state
        .setIn(['event', 'state'], fetchingState.LOADED)
        .setIn(['event', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.EVENT_FETCH_ERROR: {
      return state.setIn(['event', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_UPDATE_START: {
      return state.setIn(['event', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_UPDATE_SUCCESS: {
      return state
        .setIn(['event', 'state'], fetchingState.LOADED)
        .setIn(['event', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.EVENT_UPDATE_ERROR: {
      return state.setIn(['event', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_INACTIVATE_START:
    case actions.EVENT_ACTIVATE_START: {
      return state.setIn(['event', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_INACTIVATE_SUCCESS:
    case actions.EVENT_ACTIVATE_SUCCESS: {
      return state
        .setIn(['event', 'state'], fetchingState.LOADED)
        .setIn(['event', 'data'], fromJS(_.get(action, 'data.results[0]', {})));
    }
    case actions.EVENT_INACTIVATE_ERROR:
    case actions.EVENT_ACTIVATE_ERROR: {
      return state.setIn(['event', 'state'], fetchingState.ERROR);
    }

    case actions.SET_CURRENT_EVENT: {
      return state.setIn(
        ['event', 'data'],
        fromJS(_.get(action, 'payload', {})),
      );
    }

    case actions.EVENT_DELETE_SUCCESS:
    case actions.RESET_EVENT: {
      return state
        .setIn(['event', 'data'], fromJS({}))
        .setIn(['tags', 'data'], fromJS([]))
        .setIn(['objects', 'data'], fromJS([]));
    }

    case actions.EVENT_TAGS_FETCH_START: {
      return state.setIn(['tags', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_TAGS_FETCH_SUCCESS: {
      return state
        .setIn(['tags', 'state'], fetchingState.LOADED)
        .setIn(['tags', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.EVENT_TAGS_FETCH_ERROR: {
      return state.setIn(['tags', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_OBJECTS_FETCH_START: {
      return state.setIn(['objects', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_OBJECTS_FETCH_SUCCESS: {
      return state
        .setIn(['objects', 'state'], fetchingState.LOADED)
        .setIn(['objects', 'data'], fromJS(_.get(action, 'data.results', [])));
    }
    case actions.EVENT_OBJECTS_FETCH_ERROR: {
      return state.setIn(['objects', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_UPDATE_TAG_OBJECT_SUCCESS: {
      return state
        .setIn(['tags', 'data'], fromJS(_.get(action, 'data.results.tags', [])))
        .setIn(
          ['objects', 'data'],
          fromJS(_.get(action, 'data.results.objects', [])),
        );
    }

    case actions.EVENT_DOCUMENTS_FETCH_START: {
      return state.setIn(['documentList', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_DOCUMENTS_FETCH_SUCCESS: {
      return state
        .setIn(['documentList', 'state'], fetchingState.LOADED)
        .setIn(
          ['documentList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachments', [])),
        );
    }
    case actions.EVENT_DOCUMENTS_FETCH_ERROR: {
      return state.setIn(['documentList', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_DOCUMENT_CREATE_START: {
      return state.setIn(['documentList', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_DOCUMENT_CREATE_SUCCESS: {
      return state
        .setIn(['documentList', 'state'], fetchingState.LOADED)
        .setIn(
          ['documentList', 'data'],
          fromJS(_.get(action, 'data.results[0].fileAttachments', [])),
        );
    }
    case actions.EVENT_DOCUMENT_CREATE_ERROR: {
      return state.setIn(['documentList', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_DOCUMENT_DELETE_START: {
      return state.setIn(['documentList', 'state'], fetchingState.SAVING);
    }
    case actions.EVENT_DOCUMENT_DELETE_SUCCESS: {
      return state.setIn(['documentList', 'state'], fetchingState.LOADED).setIn(
        ['documentList', 'data'],
        fromJS(
          state
            .getIn(['documentList', 'data'])
            .toJS()
            .filter(document => document.s3ID !== action.s3ID),
        ),
      );
    }
    case actions.EVENT_DOCUMENT_DELETE_ERROR: {
      return state.setIn(['documentList', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_IMAGES_UPLOAD_START: {
      return state.setIn(['uploadedImages', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_IMAGES_UPLOAD_SUCCESS: {
      return state
        .setIn(['uploadedImages', 'state'], fetchingState.LOADED)
        .setIn(
          ['uploadedImages', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.EVENT_IMAGES_UPLOAD_ERROR: {
      return state.setIn(['uploadedImages', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_LINKED_IMAGES_FETCH_START: {
      return state.setIn(['linkedImages', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_LINKED_IMAGES_FETCH_SUCCESS: {
      return state
        .setIn(['linkedImages', 'state'], fetchingState.LOADED)
        .setIn(
          ['linkedImages', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.EVENT_LINKED_IMAGES_FETCH_ERROR: {
      return state.setIn(['linkedImages', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_LINKED_IMAGE_FETCH_START: {
      return state.setIn(['linkedImages', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_LINKED_IMAGE_FETCH_SUCCESS: {
      return state
        .setIn(['linkedImage', 'state'], fetchingState.LOADED)
        .setIn(
          ['linkedImage', 'data'],
          fromJS(_.get(action, 'data.results[0]', {})),
        );
    }
    case actions.EVENT_LINKED_IMAGE_FETCH_ERROR: {
      return state.setIn(['linkedImage', 'state'], fetchingState.ERROR);
    }

    case actions.EVENT_LINKED_IMAGE_FOR_EVENT_DELETE_SUCCESS: {
      const linkedImages = state.getIn(['linkedImages', 'data']).toJS();
      return state
        .setIn(['linkedImages', 'state'], fetchingState.LOADED)
        .setIn(
          ['linkedImages', 'data'],
          fromJS(
            linkedImages.filter(
              i => i.fileAttachmentEventID !== action.fileAttachmentEventID,
            ),
          ),
        );
    }

    case actions.EVENT_LINKED_IMAGE_FOR_IMAGE_DELETE_SUCCESS: {
      const linkedEvents = state.getIn(['linkedEvents', 'data']).toJS();
      return state
        .setIn(['linkedEvents', 'state'], fetchingState.LOADED)
        .setIn(
          ['linkedEvents', 'data'],
          fromJS(
            linkedEvents.filter(
              i => i.fileAttachmentEventID !== action.fileAttachmentEventID,
            ),
          ),
        );
    }

    case actions.EVENT_LINKED_EVENTS_FETCH_START: {
      return state.setIn(['linkedEvents', 'state'], fetchingState.FETCHING);
    }
    case actions.EVENT_LINKED_EVENTS_FETCH_SUCCESS: {
      return state
        .setIn(['linkedEvents', 'state'], fetchingState.LOADED)
        .setIn(
          ['linkedEvents', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    }
    case actions.EVENT_LINKED_EVENTS_FETCH_ERROR: {
      return state.setIn(['linkedEvents', 'state'], fetchingState.ERROR);
    }

    case actions.INIT_UPLOAD_IMAGES: {
      return state.setIn(['uploadedImages', 'data'], fromJS([]));
    }

    case actions.EVENT_IMAGE_DELETE_SUCCESS: {
      const uploadedImages = state.getIn(['uploadedImages', 'data']).toJS();
      return state.setIn(
        ['uploadedImages', 'data'],
        fromJS(
          uploadedImages.filter(
            u => u.fileAttachmentID !== action.fileAttachmentID,
          ),
        ),
      );
    }

    case actions.EVENT_IMAGE_UPDATE_SUCCESS: {
      const uploadedImages = state.getIn(['uploadedImages', 'data']).toJS();
      return state.setIn(
        ['uploadedImages', 'data'],
        fromJS(
          uploadedImages.map(u => {
            if (u.fileAttachmentID === action.fileAttachmentID) {
              return {
                ...u,
                ...action.data.results[0],
              };
            }
            return u;
          }),
        ),
      );
    }

    case actions.EVENT_IMAGE_FOR_EVENT_UPDATE_SUCCESS: {
      const linkedImages = state.getIn(['linkedImages', 'data']).toJS();
      return state.setIn(
        ['linkedImages', 'data'],
        fromJS(
          linkedImages.map(u => {
            if (u.fileAttachmentID === action.fileAttachmentID) {
              return {
                ...u,
                attachmentDescription:
                  action.data.results[0].attachmentDescription,
                fileAttachmentUpdateDt: action.data.results[0].updateDt,
                fileAttachmentUpdatedBy: action.data.results[0].updatedBy,
              };
            }
            return u;
          }),
        ),
      );
    }

    case actions.SET_PERSISTS: {
      return state.setIn(['persists'], fromJS(action.payload));
    }

    case actions.SET_LAST_EDIT_POSITION: {
      return state.setIn(['lastPosition'], action.payload);
    }

    case actions.SET_LAST_TOP_POSITION: {
      return state.setIn(['lastTopPosition'], action.payload);
    }

    default: {
      return state;
    }
  }
};
